


































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component({
    components: {
    },
    model: {
        prop: "model",
        event: "visibilityChanged"
    }
})
export default class LoadingOverlay extends Vue {
    // Member
    public visibility = true;
        
    // Properties
    @Prop({ required: false })
    public model?: boolean;

    @Prop({ required: false, type: Number, default: 10 })
    public blur!: number;

    @Prop({ required: false, type: Number, default: 1 })
    public zIndex!: number;

    @Prop({ required: false })
    public text?: string;

    // Getter & Setter
    public get visible(): boolean {
        return this.model ?? this.visibility;
    }
    public set visible(value: boolean) {
        this.visibility = value;
        this.$emit('visibilityChanged', value);
    }
}
